import React, { Component } from 'react';
import * as _ from 'lodash';
import { UsersSearchSelect } from '../../../../../../shared/users-search-select/UsersSearchSelect';
import './../../../teams/add-team/AddTeamModalContent.scss';
import { BlueContainedButton } from '../../../../../../shared/button/blue-contained-button/BlueContainedButton';
import './AddUserToTeamModalContent.scss';

export class AddUserToTeamModalContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedUser: null
        };
    }

    onAddUser = () => {
        _.isFunction(this.props.addUserToTeam) &&
            this.props.addUserToTeam(this.state.selectedUser);
    };

    handleSelectChange = newValue => {
        this.setState({
            ...this.state,
            selectedUser: newValue
        });
    };

    render = () => (
        <div className={'add-user-to-team-modal-content'}>
            <UsersSearchSelect
                users={this.props.users}
                onChange={this.handleSelectChange}
                className={'users-select'}
            />
            <BlueContainedButton
                text={'Add User'}
                disabled={!this.state.selectedUser}
                onClick={this.onAddUser}
            />
        </div>
    );
}
